// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';

// const LeaveType = () => {
//   const [leaveTypes, setLeaveTypes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editingLeaveTypeId, setEditingLeaveTypeId] = useState(null);
//   const [showAlert, setShowAlert] = useState(null);
//   const [formData, setFormData] = useState({
//     leaveType: '',
//   });
//   const [successMessage, setSuccessMessage] = useState('');
//   const [submitting, setSubmitting] = useState(false);
//   const [confirmAction, setConfirmAction] = useState(null);
//   const [showSuccessAlert, setShowSuccessAlert] = useState(null);

//   useEffect(() => {
//     fetchLeaveTypes();
//   }, []);

//   const getCompanyId = () => {
//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       return null;
//     }

//     try {
//       const decoded = jwtDecode(token);
//       return decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id || null;
//     } catch (err) {
//       console.error('Error decoding token for companyId:', err);
//       const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
//       return userInfo.companyId || userInfo.company || null;
//     }
//   };

//   const fetchLeaveTypes = async () => {
//     const token = localStorage.getItem('authToken');

//     if (!token) {
//       setError('No access token found. Please log in.');
//       setLoading(false);
//       return;
//     }

//     let decoded;
//     try {
//       decoded = jwtDecode(token);
//     } catch (err) {
//       console.error('Invalid token:', err);
//       setError('Invalid token. Please log in again.');
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('userInfo');
//       setLoading(false);
//       return;
//     }

//     const companyId = decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id;
//     if (!companyId) {
//       setError('Company ID not found in token. Please ensure you are logged in properly.');
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `https://crm-tkxn.onrender.com/api/leave-types/company/${companyId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           validateStatus: (status) => status < 500,
//         }
//       );

//       if (response.status === 401) {
//         setError('Session expired. Please log in again.');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userInfo');
//         window.location.href = '/login';
//         return;
//       }

//       if (response.status >= 400) {
//         throw new Error(`HTTP ${response.status}: ${response.data?.message || 'Request failed'}`);
//       }

//       let leaveTypesData = [];
//       if (Array.isArray(response.data)) {
//         leaveTypesData = response.data;
//       } else if (response.data && Array.isArray(response.data.data)) {
//         leaveTypesData = response.data.data;
//       } else if (response.data && Array.isArray(response.data.leaveTypes)) {
//         leaveTypesData = response.data.leaveTypes;
//       } else {
//         console.warn('Unexpected response data structure:', response.data);
//         leaveTypesData = [];
//       }

//       setLeaveTypes(leaveTypesData);
//       setError(null);
//     } catch (err) {
//       console.error("Error fetching leave types:", {
//         error: err,
//         response: err.response,
//         status: err.response?.status,
//         data: err.response?.data,
//         message: err.message
//       });

//       setLeaveTypes([]);

//       if (err.response?.status === 401) {
//         setError('Session expired. Please log in again.');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userInfo');
//         window.location.href = '/login';
//       } else if (err.response?.status === 404) {
//         setError('Leave types endpoint not found. Please contact support.');
//       } else if (err.response?.status === 403) {
//         setError('Access denied. You do not have permission to view leave types.');
//       } else {
//         const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch leave types. Please try again.';
//         setError(errorMessage);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     const textOnlyRegex = /^[A-Za-z\s]*$/;

//     if (name === "leaveType" && !textOnlyRegex.test(value)) {
//       return;
//     }

//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//   };

//   const handleAddLeaveType = async (e) => {
//     e.preventDefault();

//     if (!formData.leaveType.trim()) {
//       setShowAlert('Please enter a leave type name.');
//       return;
//     }

//     const token = localStorage.getItem('authToken');

//     if (!token) {
//       setShowAlert('Access token not found. Please login.');
//       return;
//     }

//     let decoded;
//     try {
//       decoded = jwtDecode(token);
//     } catch (err) {
//       console.error('Invalid token:', err);
//       setShowAlert('Invalid token. Please log in again.');
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('userInfo');
//       return;
//     }

//     const companyId = decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id;
//     if (!companyId) {
//       setShowAlert('Company ID not found in token. Please ensure you are logged in properly.');
//       return;
//     }

//     setSubmitting(true);

//     const payload = {
//       leaveType: formData.leaveType.trim(),
//       company: companyId,
//     };

//     try {
//       const response = await axios.post(
//         'https://crm-tkxn.onrender.com/api/leave-types/',
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//           validateStatus: (status) => status < 500,
//         }
//       );

//       if (response.status === 401) {
//         setShowAlert('Session expired. Please log in again.');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userInfo');
//         window.location.href = '/login';
//         return;
//       }

//       if (response.status >= 400) {
//         const errorMessage = response.data?.message || `HTTP ${response.status}: Request failed`;
//         setShowAlert(errorMessage);
//         return;
//       }

//       setShowSuccessAlert('Leave type created successfully!');
//       fetchLeaveTypes();
//       resetForm();
//     } catch (error) {
//       console.error("Error creating leave type:", error.response?.data || error.message || error);
//       if (error.response?.status === 401) {
//         setShowAlert('Session expired. Please log in again.');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userInfo');
//         window.location.href = '/login';
//       } else {
//         const errorMessage = error.response?.data?.message || 'Error creating leave type. Please try again.';
//         setShowAlert(errorMessage);
//       }
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleEditLeaveType = (leaveType) => {
//     setIsEditing(true);
//     setEditingLeaveTypeId(leaveType._id);
//     setFormData({
//       leaveType: leaveType.leaveType || '',
//     });
//     setShowForm(true);
//   };

//   const handleUpdateLeaveType = async (e) => {
//     e.preventDefault();

//     if (!formData.leaveType.trim()) {
//       setShowAlert('Please enter a leave type name.');
//       return;
//     }

//     const token = localStorage.getItem('authToken');
//     if (!token) {
//       setShowAlert('Access token not found. Please login.');
//       return;
//     }

//     try {
//       jwtDecode(token);
//     } catch (err) {
//       console.error('Invalid token:', err);
//       setShowAlert('Invalid token. Please log in again.');
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('userInfo');
//       return;
//     }

//     setSubmitting(true);

//     const payload = {
//       leaveType: formData.leaveType.trim(),
//     };

//     try {
//       const response = await axios.put(
//         `https://crm-tkxn.onrender.com/api/leave-types/${editingLeaveTypeId}`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//           validateStatus: (status) => status < 500,
//         }
//       );

//       if (response.status === 401) {
//         setShowAlert('Session expired. Please log in again.');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userInfo');
//         window.location.href = '/login';
//         return;
//       }

//       if (response.status >= 400) {
//         const errorMessage = response.data?.message || `HTTP ${response.status}: Request failed`;
//         setShowAlert(errorMessage);
//         return;
//       }

//       setShowSuccessAlert('Leave type updated successfully!');
//       fetchLeaveTypes();
//       resetForm();
//     } catch (error) {
//       console.error("Error updating leave type:", error.response?.data || error.message || error);
//       if (error.response?.status === 401) {
//         setShowAlert('Session expired. Please log in again.');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userInfo');
//         window.location.href = '/login';
//       } else {
//         const errorMessage = error.response?.data?.message || 'Error updating leave type. Please try again.';
//         setShowAlert(errorMessage);
//       }
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Handle delete confirmation
//   const handleDeleteLeaveType = (leaveTypeId, leaveTypeName) => {
//     setConfirmAction({
//       type: 'delete',
//       message: `Are you sure you want to delete the leave type "${leaveTypeName}"?`,
//       leaveTypeId: leaveTypeId
//     });
//   };

//   // Execute the confirmed action
//   const handleConfirmAction = async () => {
//     const token = localStorage.getItem('authToken');

//     if (!token) {
//       setShowAlert('No access token found. Please log in.');
//       setConfirmAction(null);
//       return;
//     }

//     try {
//       setSubmitting(true);

//       if (confirmAction.type === 'delete') {
//         const response = await axios.delete(
//           `https://crm-tkxn.onrender.com/api/leave-types/${confirmAction.leaveTypeId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//             validateStatus: (status) => status < 500,
//           }
//         );

//         if (response.status === 401) {
//           setShowAlert('Session expired. Please log in again.');
//           localStorage.removeItem('authToken');
//           localStorage.removeItem('userInfo');
//           window.location.href = '/login';
//           return;
//         }

//         if (response.status >= 400) {
//           const errorMessage = response.data?.message || `HTTP ${response.status}: Request failed`;
//           setShowAlert(errorMessage);
//           return;
//         }

//         setShowSuccessAlert('Leave type deleted successfully!');
//         fetchLeaveTypes();
//       }

//     } catch (error) {
//       console.error("Error performing leave type operation:", error.response?.data || error.message || error);
//       if (error.response?.status === 401) {
//         setShowAlert('Session expired. Please log in again.');
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('userInfo');
//         window.location.href = '/login';
//       } else {
//         const errorMessage = error.response?.data?.message || `Error ${confirmAction.type}ing leave type. Please try again.`;
//         setShowAlert(errorMessage);
//       }
//     } finally {
//       setSubmitting(false);
//       setConfirmAction(null);
//     }
//   };

//   // Close confirmation dialog
//   const handleCloseAlert = () => {
//     setConfirmAction(null);
//   };

//   // Close success alert
//   const handleCloseSuccessAlert = () => {
//     setShowSuccessAlert(null);
//   };

//   const resetForm = () => {
//     setFormData({
//       leaveType: '',
//     });
//     setShowForm(false);
//     setIsEditing(false);
//     setEditingLeaveTypeId(null);
//   };

//   const retryFetch = () => {
//     setError(null);
//     setLoading(true);
//     fetchLeaveTypes();
//   };

//   const debugTokenInfo = () => {
//     const token = localStorage.getItem('authToken');
//     console.log('Debug Token Info:');
//     console.log('Token exists:', !!token);

//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         console.log('Decoded token:', decoded);
//         console.log('Company ID from token:', decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id);
//       } catch (err) {
//         console.error('Token decode error:', err);
//       }
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading leave types...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
//         <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
//           <div className="text-red-500 text-center">
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             <p className="text-lg font-medium mb-4">{error}</p>
//             <div className="flex gap-2 justify-center">
//               <button
//                 onClick={retryFetch}
//                 className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200"
//               >
//                 Retry
//               </button>
//               <button
//                 onClick={debugTokenInfo}
//                 className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
//               >
//                 Debug Info
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-8 px-4">
//       <div className="max-w-6xl mx-auto">
//         {/* Success Message */}
//         {successMessage && (
//           <div className="mb-6 p-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl shadow-lg animate-fade-in">
//             <div className="flex items-center">
//               <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               {successMessage}
//             </div>
//           </div>
//         )}

//         {/* Header */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10">
//           <div className="mb-6 md:mb-0">
//             <div className="flex items-center mb-3">
//               <div className="p-3 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-md mr-4">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//               </div>
//               <h1 className="text-4xl font-bold text-slate-800">Leave Type Management</h1>
//             </div>
//             <p className="text-slate-600 ml-16">Manage leave types for your company</p>
//           </div>
//           <button
//             onClick={() => {
//               if (showForm) resetForm();
//               else setShowForm(true);
//             }}
//             className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center shadow-md hover:shadow-lg"
//           >
//             <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
//               <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
//             </svg>
//             {showForm ? 'Cancel' : 'Add Leave Type'}
//           </button>
//         </div>

//         {showForm && (
//           <div className="bg-white rounded-2xl shadow-xl p-6 mb-10 border border-slate-100 animate-slide-down">
//             <div className="flex items-center mb-6">
//               <div className="p-2 bg-indigo-100 rounded-lg mr-3">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//                 </svg>
//               </div>
//               <h2 className="text-2xl font-semibold text-slate-800">
//                 {isEditing ? 'Edit Leave Type' : 'Add New Leave Type'}
//               </h2>
//             </div>
//             <form onSubmit={isEditing ? handleUpdateLeaveType : handleAddLeaveType} className="space-y-6">
//               <div>
//                 <label className="block text-sm font-medium text-slate-700 mb-2">
//                   Leave Type Name *
//                 </label>
//                 <input
//                   type="text"
//                   name="leaveType"
//                   value={formData.leaveType}
//                   onChange={handleInputChange}
//                   required
//                   disabled={submitting}
//                   className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors shadow-sm disabled:bg-slate-100 disabled:cursor-not-allowed"
//                   placeholder="Enter leave type name (e.g., Annual Leave, Sick Leave, Maternity Leave)"
//                 />
//               </div>

//               <div className="flex gap-4">
//                 <button
//                   type="submit"
//                   disabled={submitting}
//                   className="px-8 py-3 bg-gradient-to-r from-green-500 to-teal-600 text-white font-semibold rounded-lg hover:from-green-600 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   {submitting ? (
//                     <>
//                       <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
//                       {isEditing ? 'Updating...' : 'Creating...'}
//                     </>
//                   ) : (
//                     <>
//                       <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                       </svg>
//                       {isEditing ? 'Update Leave Type' : 'Create Leave Type'}
//                     </>
//                   )}
//                 </button>
//                 <button
//                   type="button"
//                   onClick={resetForm}
//                   disabled={submitting}
//                   className="px-6 py-3 bg-slate-500 text-white font-semibold rounded-lg hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         )}

//         <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-slate-100">
//           <div className="px-6 py-4 border-b border-slate-200 bg-slate-50">
//             <div className="flex items-center justify-between">
//               <div className="flex items-center">
//                 <div className="p-2 bg-indigo-100 rounded-lg mr-3">
//                   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//                   </svg>
//                 </div>
//                 <h2 className="text-xl font-semibold text-slate-800">Leave Types List</h2>
//               </div>
//               <p className="text-slate-600 text-sm ml-10">{Array.isArray(leaveTypes) ? leaveTypes.length : 0} leave type{(Array.isArray(leaveTypes) ? leaveTypes.length : 0) !== 1 ? 's' : ''} found</p>
//               <button
//                 onClick={() => {
//                   console.log('Manual refresh triggered');
//                   fetchLeaveTypes();
//                 }}
//                 className="px-4 py-2 bg-gradient-to-r from-blue-100 to-cyan-100 text-blue-600 rounded-lg hover:from-blue-200 hover:to-cyan-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 flex items-center shadow-sm"
//                 title="Refresh leave types list"
//               >
//                 <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                 </svg>
//                 Refresh
//               </button>
//             </div>
//           </div>

//           {!Array.isArray(leaveTypes) || leaveTypes.length === 0 ? (
//             <div className="p-12 text-center">
//               <div className="mx-auto w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                 </svg>
//               </div>
//               <p className="mt-4 text-slate-600">No leave types found. Add your first leave type to get started.</p>
//               <button
//                 onClick={() => setShowForm(true)}
//                 className="mt-4 px-6 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 transform hover:-translate-y-1 shadow-md"
//               >
//                 Add First Leave Type
//               </button>
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-slate-200">
//                 <thead className="bg-slate-50">
//                   <tr>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       ID
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Leave Type
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Created Date
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-slate-200">
//                   {Array.isArray(leaveTypes) && leaveTypes.map((leaveType, index) => (
//                     <tr key={leaveType._id} className="hover:bg-slate-50 transition-colors duration-150">
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
//                         <div className="w-8 h-8 flex items-center justify-center bg-slate-100 rounded-lg">
//                           {index + 1}
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap">
//                         <div className="flex items-center">
//                           <div className="flex-shrink-0 h-10 w-10 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-lg flex items-center justify-center mr-3 shadow-sm">
//                             <svg className="h-5 w-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                             </svg>
//                           </div>
//                           <span className="text-sm font-medium text-slate-800">{leaveType.leaveType}</span>
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">
//                         {leaveType.createdAt ? new Date(leaveType.createdAt).toLocaleDateString() : 'N/A'}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                         <div className="flex space-x-3">
//                           <button 
//                             onClick={() => handleEditLeaveType(leaveType)}
//                             className="text-indigo-600 hover:text-indigo-800 px-3 py-1 rounded-lg hover:bg-indigo-50 transition-colors duration-200 flex items-center"
//                           >
//                             <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                             </svg>
//                             Edit
//                           </button>
//                           <button 
//                             onClick={() => handleDeleteLeaveType(leaveType._id, leaveType.leaveType)}
//                             className="text-red-600 hover:text-red-800 px-3 py-1 rounded-lg hover:bg-red-50 transition-colors duration-200 flex items-center"
//                           >
//                             <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                             </svg>
//                             Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Confirmation Alert Dialog */}
//       {confirmAction && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
//           <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm text-center">
//             <h2 className="text-lg font-semibold text-gray-800 mb-4">Confirmation</h2>
//             <p className="text-gray-700 mb-6">{confirmAction.message}</p>
//             <div className="flex justify-center space-x-4">
//               <button
//                 onClick={handleConfirmAction}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
//                 disabled={submitting}
//               >
//                 {submitting ? 'Processing...' : 'Confirm'}
//               </button>
//               <button
//                 onClick={handleCloseAlert}
//                 className="px-4 py-2 bg-gray-300 text-gray-700 rounded-xl hover:bg-gray-400 transition"
//                 disabled={submitting}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Success Alert Dialog */}
//       {showSuccessAlert && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
//           <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm text-center">
//             <h2 className="text-lg font-semibold text-gray-800 mb-4">Success</h2>
//             <p className="text-gray-700 mb-6">{showSuccessAlert}</p>
//             <div className="flex justify-center">
//               <button
//                 onClick={handleCloseSuccessAlert}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes slideDown {
//           from { transform: translateY(-10px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }
//         .animate-fade-in {
//           animation: fadeIn 0.3s ease-out;
//         }
//         .animate-slide-down {
//           animation: slideDown 0.3s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default LeaveType;



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const LeaveType = () => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingLeaveTypeId, setEditingLeaveTypeId] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [formData, setFormData] = useState({
    leaveType: '',
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(null);

  useEffect(() => {
    fetchLeaveTypes();
  }, []);

  const getCompanyId = () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return null;
    }

    try {
      const decoded = jwtDecode(token);
      return decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id || null;
    } catch (err) {
      console.error('Error decoding token for companyId:', err);
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo.companyId || userInfo.company || null;
    }
  };

  const fetchLeaveTypes = async () => {
    const token = localStorage.getItem('authToken');

    if (!token) {
      setError('No access token found. Please log in.');
      setLoading(false);
      return;
    }

    let decoded;
    try {
      decoded = jwtDecode(token);
    } catch (err) {
      console.error('Invalid token:', err);
      setError('Invalid token. Please log in again.');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userInfo');
      setLoading(false);
      return;
    }

    const companyId = decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id;
    if (!companyId) {
      setError('Company ID not found in token. Please ensure you are logged in properly.');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `https://crm-tkxn.onrender.com/api/leave-types/company/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          validateStatus: (status) => status < 500,
        }
      );

      if (response.status === 401) {
        setError('Session expired. Please log in again.');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/login';
        return;
      }

      if (response.status >= 400) {
        throw new Error(`HTTP ${response.status}: ${response.data?.message || 'Request failed'}`);
      }

      let leaveTypesData = [];
      if (Array.isArray(response.data)) {
        leaveTypesData = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        leaveTypesData = response.data.data;
      } else if (response.data && Array.isArray(response.data.leaveTypes)) {
        leaveTypesData = response.data.leaveTypes;
      } else {
        console.warn('Unexpected response data structure:', response.data);
        leaveTypesData = [];
      }

      setLeaveTypes(leaveTypesData);
      setError(null);
    } catch (err) {
      console.error("Error fetching leave types:", {
        error: err,
        response: err.response,
        status: err.response?.status,
        data: err.response?.data,
        message: err.message
      });

      setLeaveTypes([]);

      if (err.response?.status === 401) {
        setError('Session expired. Please log in again.');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/login';
      } else if (err.response?.status === 404) {
        setError('Leave types endpoint not found. Please contact support.');
      } else if (err.response?.status === 403) {
        setError('Access denied. You do not have permission to view leave types.');
      } else {
        const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch leave types. Please try again.';
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const textOnlyRegex = /^[A-Za-z\s]*$/;

    if (name === "leaveType" && !textOnlyRegex.test(value)) {
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleAddLeaveType = async (e) => {
    e.preventDefault();

    if (!formData.leaveType.trim()) {
      setShowAlert('Please enter a leave type name.');
      return;
    }

    const token = localStorage.getItem('authToken');

    if (!token) {
      setShowAlert('Access token not found. Please login.');
      return;
    }

    let decoded;
    try {
      decoded = jwtDecode(token);
    } catch (err) {
      console.error('Invalid token:', err);
      setShowAlert('Invalid token. Please log in again.');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userInfo');
      return;
    }

    const companyId = decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id;
    if (!companyId) {
      setShowAlert('Company ID not found in token. Please ensure you are logged in properly.');
      return;
    }

    setSubmitting(true);

    const payload = {
      leaveType: formData.leaveType.trim(),
      company: companyId,
    };

    try {
      const response = await axios.post(
        'https://crm-tkxn.onrender.com/api/leave-types/',
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          validateStatus: (status) => status < 500,
        }
      );

      if (response.status === 401) {
        setShowAlert('Session expired. Please log in again.');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/login';
        return;
      }

      if (response.status >= 400) {
        const errorMessage = response.data?.message || `HTTP ${response.status}: Request failed`;
        setShowAlert(errorMessage);
        return;
      }

      setShowSuccessAlert('Leave type created successfully!');
      fetchLeaveTypes();
      resetForm();
    } catch (error) {
      console.error("Error creating leave type:", error.response?.data || error.message || error);
      if (error.response?.status === 401) {
        setShowAlert('Session expired. Please log in again.');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/login';
      } else {
        const errorMessage = error.response?.data?.message || 'Error creating leave type. Please try again.';
        setShowAlert(errorMessage);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleEditLeaveType = (leaveType) => {
    setIsEditing(true);
    setEditingLeaveTypeId(leaveType._id);
    setFormData({
      leaveType: leaveType.leaveType || '',
    });
    setShowForm(true);
  };

  const handleUpdateLeaveType = async (e) => {
    e.preventDefault();

    if (!formData.leaveType.trim()) {
      setShowAlert('Please enter a leave type name.');
      return;
    }

    const token = localStorage.getItem('authToken');
    if (!token) {
      setShowAlert('Access token not found. Please login.');
      return;
    }

    try {
      jwtDecode(token);
    } catch (err) {
      console.error('Invalid token:', err);
      setShowAlert('Invalid token. Please log in again.');
      localStorage.removeItem('authToken');
      localStorage.removeItem('userInfo');
      return;
    }

    setSubmitting(true);

    const payload = {
      leaveType: formData.leaveType.trim(),
    };

    try {
      const response = await axios.put(
        `https://crm-tkxn.onrender.com/api/leave-types/${editingLeaveTypeId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          validateStatus: (status) => status < 500,
        }
      );

      if (response.status === 401) {
        setShowAlert('Session expired. Please log in again.');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/login';
        return;
      }

      if (response.status >= 400) {
        const errorMessage = response.data?.message || `HTTP ${response.status}: Request failed`;
        setShowAlert(errorMessage);
        return;
      }

      setShowSuccessAlert('Leave type updated successfully!');
      fetchLeaveTypes();
      resetForm();
    } catch (error) {
      console.error("Error updating leave type:", error.response?.data || error.message || error);
      if (error.response?.status === 401) {
        setShowAlert('Session expired. Please log in again.');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/login';
      } else {
        const errorMessage = error.response?.data?.message || 'Error updating leave type. Please try again.';
        setShowAlert(errorMessage);
      }
    } finally {
      setSubmitting(false);
    }
  };

  // Handle delete confirmation
  const handleDeleteLeaveType = (leaveTypeId, leaveTypeName) => {
    setConfirmAction({
      type: 'delete',
      message: `Are you sure you want to delete the leave type "${leaveTypeName}"?`,
      leaveTypeId: leaveTypeId
    });
  };

  // Execute the confirmed action
  const handleConfirmAction = async () => {
    const token = localStorage.getItem('authToken');

    if (!token) {
      setShowAlert('No access token found. Please log in.');
      setConfirmAction(null);
      return;
    }

    try {
      setSubmitting(true);

      if (confirmAction.type === 'delete') {
        const response = await axios.delete(
          `https://crm-tkxn.onrender.com/api/leave-types/${confirmAction.leaveTypeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            validateStatus: (status) => status < 500,
          }
        );

        if (response.status === 401) {
          setShowAlert('Session expired. Please log in again.');
          localStorage.removeItem('authToken');
          localStorage.removeItem('userInfo');
          window.location.href = '/login';
          return;
        }

        if (response.status >= 400) {
          const errorMessage = response.data?.message || `HTTP ${response.status}: Request failed`;
          setShowAlert(errorMessage);
          return;
        }

        setShowSuccessAlert('Leave type deleted successfully!');
        fetchLeaveTypes();
      }

    } catch (error) {
      console.error("Error performing leave type operation:", error.response?.data || error.message || error);
      if (error.response?.status === 401) {
        setShowAlert('Session expired. Please log in again.');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userInfo');
        window.location.href = '/login';
      } else {
        const errorMessage = error.response?.data?.message || `Error ${confirmAction.type}ing leave type. Please try again.`;
        setShowAlert(errorMessage);
      }
    } finally {
      setSubmitting(false);
      setConfirmAction(null);
    }
  };

  // Close confirmation dialog
  const handleCloseAlert = () => {
    setConfirmAction(null);
  };

  // Close success alert
  const handleCloseSuccessAlert = () => {
    setShowSuccessAlert(null);
  };

  const resetForm = () => {
    setFormData({
      leaveType: '',
    });
    setShowForm(false);
    setIsEditing(false);
    setEditingLeaveTypeId(null);
  };

  const retryFetch = () => {
    setError(null);
    setLoading(true);
    fetchLeaveTypes();
  };

  const debugTokenInfo = () => {
    const token = localStorage.getItem('authToken');
    console.log('Debug Token Info:');
    console.log('Token exists:', !!token);

    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log('Decoded token:', decoded);
        console.log('Company ID from token:', decoded.companyId || decoded.company?._id || decoded.orgId || decoded.id);
      } catch (err) {
        console.error('Token decode error:', err);
      }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading leave types...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
          <div className="text-red-500 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-lg font-medium mb-4">{error}</p>
            <div className="flex gap-2 justify-center">
              <button
                onClick={retryFetch}
                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200"
              >
                Retry
              </button>
              <button
                onClick={debugTokenInfo}
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
              >
                Debug Info
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-2 md:p-4">
      <div className="max-w-full mx-auto">
        {/* Success Message */}
        {successMessage && (
          <div className="mb-6 p-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl shadow-lg animate-fade-in">
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              {successMessage}
            </div>
          </div>
        )}

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10">
          <div className="mb-6 md:mb-0">
            <div className="flex items-center mb-3">
              <div className="p-3 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl shadow-md mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h1 className="text-4xl font-bold text-slate-800">Leave Type Management</h1>
            </div>
            <p className="text-slate-600 ml-16">Manage leave types for your company</p>
          </div>
          <button
            onClick={() => {
              if (showForm) resetForm();
              else setShowForm(true);
            }}
            className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-xl hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center shadow-md hover:shadow-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
            </svg>
            {showForm ? 'Cancel' : 'Add Leave Type'}
          </button>
        </div>

        {showForm && (
          <div className="bg-white rounded-2xl shadow-xl p-6 mb-10 border border-slate-100 animate-slide-down">
            <div className="flex items-center mb-6">
              <div className="p-2 bg-indigo-100 rounded-lg mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
              </div>
              <h2 className="text-2xl font-semibold text-slate-800">
                {isEditing ? 'Edit Leave Type' : 'Add New Leave Type'}
              </h2>
            </div>
            <form onSubmit={isEditing ? handleUpdateLeaveType : handleAddLeaveType} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Leave Type Name *
                </label>
                <input
                  type="text"
                  name="leaveType"
                  value={formData.leaveType}
                  onChange={handleInputChange}
                  required
                  disabled={submitting}
                  className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors shadow-sm disabled:bg-slate-100 disabled:cursor-not-allowed"
                  placeholder="Enter leave type name (e.g., Annual Leave, Sick Leave, Maternity Leave)"
                />
              </div>

              <div className="flex gap-4">
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-8 py-3 bg-gradient-to-r from-green-500 to-teal-600 text-white font-semibold rounded-lg hover:from-green-600 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {submitting ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                      {isEditing ? 'Updating...' : 'Creating...'}
                    </>
                  ) : (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      {isEditing ? 'Update Leave Type' : 'Create Leave Type'}
                    </>
                  )}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  disabled={submitting}
                  className="px-6 py-3 bg-slate-500 text-white font-semibold rounded-lg hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-slate-100">
          <div className="px-6 py-4 border-b border-slate-200 bg-slate-50">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="p-2 bg-indigo-100 rounded-lg mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                </div>
                <h2 className="text-xl font-semibold text-slate-800">Leave Types List</h2>
              </div>
              <p className="text-slate-600 text-sm ml-10">{Array.isArray(leaveTypes) ? leaveTypes.length : 0} leave type{(Array.isArray(leaveTypes) ? leaveTypes.length : 0) !== 1 ? 's' : ''} found</p>
              <button
                onClick={() => {
                  console.log('Manual refresh triggered');
                  fetchLeaveTypes();
                }}
                className="px-4 py-2 bg-gradient-to-r from-blue-100 to-cyan-100 text-blue-600 rounded-lg hover:from-blue-200 hover:to-cyan-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 flex items-center shadow-sm"
                title="Refresh leave types list"
              >
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Refresh
              </button>
            </div>
          </div>

          {!Array.isArray(leaveTypes) || leaveTypes.length === 0 ? (
            <div className="p-12 text-center">
              <div className="mx-auto w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <p className="mt-4 text-slate-600">No leave types found. Add your first leave type to get started.</p>
              <button
                onClick={() => setShowForm(true)}
                className="mt-4 px-6 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 transform hover:-translate-y-1 shadow-md"
              >
                Add First Leave Type
              </button>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-slate-200">
                <thead className="bg-slate-50">
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                      ID
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                      Leave Type
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                      Created Date
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-slate-200">
                  {Array.isArray(leaveTypes) && leaveTypes.map((leaveType, index) => (
                    <tr key={leaveType._id} className="hover:bg-slate-50 transition-colors duration-150">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                        <div className="w-8 h-8 flex items-center justify-center bg-slate-100 rounded-lg">
                          {index + 1}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                            <svg className="h-5 w-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </div>
                          <span className="text-sm font-medium text-slate-800">{leaveType.leaveType}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">
                        {leaveType.createdAt ? new Date(leaveType.createdAt).toLocaleDateString('en-GB') : 'N/A'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex space-x-3">
                          <button
                            onClick={() => handleEditLeaveType(leaveType)}
                            className="text-indigo-600 hover:text-indigo-800 px-3 py-1 rounded-lg hover:bg-indigo-50 transition-colors duration-200 flex items-center"
                          >
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteLeaveType(leaveType._id, leaveType.leaveType)}
                            className="text-red-600 hover:text-red-800 px-3 py-1 rounded-lg hover:bg-red-50 transition-colors duration-200 flex items-center"
                          >
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Confirmation Alert Dialog */}
      {confirmAction && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm text-center">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Confirmation</h2>
            <p className="text-gray-700 mb-6">{confirmAction.message}</p>
            <div className="flex justify-center space-x-4">
              <button
                onClick={handleConfirmAction}
                className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
                disabled={submitting}
              >
                {submitting ? 'Processing...' : 'Confirm'}
              </button>
              <button
                onClick={handleCloseAlert}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-xl hover:bg-gray-400 transition"
                disabled={submitting}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Alert Dialog */}
      {showSuccessAlert && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-2xl shadow-lg p-6 w-[90%] max-w-sm text-center">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Success</h2>
            <p className="text-gray-700 mb-6">{showSuccessAlert}</p>
            <div className="flex justify-center">
              <button
                onClick={handleCloseSuccessAlert}
                className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideDown {
          from { transform: translateY(-10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-fade-in {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slide-down {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default LeaveType;

